/**
 * @module builder
 */
import type { QuoteDocument, Payment } from 'paintscout'

export function getPayments(args: { quote: QuoteDocument }): Payment[] {
  return args?.quote?.payments ? [...args.quote.payments] : []
}
